var Reflux = require('@muzzylane/reflux'),
    ServerRequest = require('./request'),
    ErrorConsts = require('../constants/error'),
    ForgeError = require('../util/error');

var SignUpActions = Reflux.createActions({
    "signUp": {children: ["completed","failed"]}
});

SignUpActions.signUp.listen(function(actionID, params) {
    var self = this;
    var valid = true;
    var errorUIRefs = [];
    var errorMsg;

    if(!params.email1){
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("email1");
    }

    if(!params.email2){
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("email2");
    }

    // if(!params.token){
    //     valid = false;
    //     errorMsg = ErrorConsts.MISSING_PARAMS;
    //     errorUIRefs.push("token");
    // }

    if(!params.captchaToken) {
        valid = false;
        errorMsg = ErrorConsts.INVALID_CAPTCHA;
    }

    if(valid && (params.email1 !== params.email2)){
        valid = false;
        errorMsg = ErrorConsts.EMAIL_MATCH;
        errorUIRefs.push("email1", "email2");
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/signup/token', 'POST', JSON.stringify({
            email: params.email1,
            token: params.token || '',
            captchaToken: params.captchaToken,
            redirectToPath: params.redirectToPath || '',
        }))
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});

module.exports = SignUpActions;
